<template>
  <main class="content-body">
    <header class="page-header">
      <h2>Zone A</h2>
    </header>
    <div v-if="isAdminOrSuperAdmin" class="row">
      <div class="col-md-12 col-lg-12 col-xl-12">
        <section class="panel">
          <header class="panel-heading">
            <h2 class="panel-title">Administration</h2>
          </header>
          <div class="panel-body">
            <div class="row">
              <div class="col-sm-12">
                <ul class="za-nav">
                  <router-link :to="{name: 'version'}"
                    v-slot="{ href, route, navigate, isActive, isExactActive }">
                    <li @click="navigate" :class="['za-nav-item', isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
                      <a :href="href"><i class="fas fa-fw fa-code-branch fa-spacer"></i>Version</a>
                    </li>
                  </router-link>

                  <router-link v-if="isSuperAdmin" :to="{name: 'admin-fournisseurs'}"
                    v-slot="{ href, route, navigate, isActive, isExactActive }">
                    <li @click="navigate" :class="['za-nav-item', isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
                      <a :href="href"><i class="fa fa-user-friends fa-spacer"></i>Fournisseurs</a>
                    </li>
                  </router-link>

                  <router-link v-if="isSuperAdmin" :to="{name: 'scripts'}"
                    v-slot="{ href, route, navigate, isActive, isExactActive }">
                    <li @click="navigate" :class="['za-nav-item', isActive && 'router-link-active', isExactActive && 'router-link-exact-active']">
                      <a :href="href"><i class="fas fa-cogs fa-spacer"></i>Scripts</a>
                    </li>
                  </router-link>

                </ul>
              </div>
            </div>
            <div class="row" style="padding-top: 15px;">
              <div class="col-xl-12 mb-md">
                <router-view></router-view>
              </div>
            </div>

          </div>
        </section>
      </div>
    </div>
  </main>
</template>

<script>

import axios from 'axios';
import Grid from '@/components/Grid.vue';
import {privileges} from '@/mixins/privileges.js';

//import vueMultiSelect from 'vue-multi-select';
//import 'vue-multi-select/dist/lib/vue-multi-select.css';

export default {
  name: 'AdministrationTop',
  mixins: [privileges],

  data: function() {return {
  }},

  components: {
    Grid,
  },

  methods: {
  },
  mounted () {
  },
}
</script>
